import { Component, inject } from '@angular/core';
import { IconKey } from '@common/classes/icons';
import { ButtonComponent } from '@common/components/button/button.component';
import { NgIcon } from '@ng-icons/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
    DialogActionsComponent,
    DialogContentBase,
    DialogRef,
    DialogTitleBarComponent
} from '@progress/kendo-angular-dialog';

export interface DialogConfirmOptions {
    title: string;
    titleIcons?: IconKey[];
    message: string;
    hideCancel?: boolean;
    cancelText?: string;
    confirmText?: string;
}

@Component({
    template: `
        <kendo-dialog-titlebar class="bg-background! text-primary! pt-6! pr-3! pb-5! pl-5! font-bold">
            <div class="flex flex-row items-center gap-2">
                @for (icon of options?.titleIcons; track icon) {
                    <ng-icon [name]="icon" />
                }
                {{ options?.title | translate }}
            </div>
        </kendo-dialog-titlebar>
        <div class="flex h-full flex-col justify-evenly gap-4 p-4">
            <h6>{{ options.message | translate }}</h6>
        </div>
        <kendo-dialog-actions class="px-4" layout="end">
            <div class="flex justify-end space-x-4 sm:space-x-2">
                @if (!options.hideCancel) {
                    <app-button variant="secondary" (clicked)="dialog.close(false)">
                        {{ options?.cancelText | translate }}
                    </app-button>
                }
                <app-button variant="primary" (clicked)="dialog.close(true)">
                    {{ options?.confirmText | translate }}
                </app-button>
            </div>
        </kendo-dialog-actions>
    `,
    imports: [DialogTitleBarComponent, NgIcon, TranslatePipe, DialogActionsComponent, ButtonComponent]
})
export class DialogConfirmComponent extends DialogContentBase {
    options: DialogConfirmOptions = {
        title: 'Dialog',
        message: 'Message',
        hideCancel: false,
        cancelText: 'Cancel',
        confirmText: 'Confirm'
    };

    constructor() {
        super(inject(DialogRef));
    }

    public initialize(options: DialogConfirmOptions) {
        for (const [key, value] of Object.entries(options)) {
            if (value !== undefined && value !== null) this.options[key] = value;
        }
    }
}
